import { create } from 'zustand';
import { IFinishedPractice } from '../model';

interface IFinishedPracticeState {
  practice: IFinishedPractice | null;
  setPractice: (practice: IFinishedPractice) => void;
}

export const practiceFinishedStore = create<IFinishedPracticeState>((set) => ({
  practice: null,
  setPractice: (practice: IFinishedPractice) => set({ practice }),
}));
